import React, { Component } from 'react';
import Driver from './driver.jsx';
export default class DriversTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers: props.drivers || null,
      isLoading: !props.drivers,
      url: props.url || null,
      viewJustOneDriver: props.viewJustOneDriver || false,
      viewAllJobs: props.viewAllJobs || false,
      jobs: props.jobs || [],
      setLateDriverMsg:[],
      lateDriverJobIds:[]
    };
    this.handleLateDrivers = this.handleLateDrivers.bind(this);
    this.saveLateJobIdsOFDriver = this.saveLateJobIdsOFDriver.bind(this);
  }
  getDrivers() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((response) => {

        if ((this.state.viewJustOneDriver === true) &&
            (this.state.viewAllJobs === true)) {
          this.setState({
            drivers: response,
            isLoading: false
          });
        }
        else {
          this.setState({
            drivers: response,
            isLoading: false
          });
        }
      });
    });
  }
  componentDidMount() {
    // [TODO] add realtime stuff
    if (this.state.isLoading === true) {
      this.getDrivers();
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      drivers: nextProps.drivers
    });
  }
  saveLateJobIdsOFDriver(jobsID){
    
    if(!this.state.lateDriverJobIds.includes(jobsID)){
      var joined = this.state.lateDriverJobIds.concat(jobsID);
      this.setState({ lateDriverJobIds: joined },()=>{
        return fetch('/api/v1/portal/jobs/latedriver/updatejob/'+jobsID, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer '+window.api_token
            ,"Accept": 'application/json'
          },
        }).
        then((responseText) => {
          let response = responseText.json();
        });
      });
    }
  }
  /**
   * @deprecated
   * @param {*} someval 
   * @param {*} driverID 
   * @returns 
   */
  handleLateDrivers(someval,driverID){
    
    if(someval !== null){
      if(this.state.setLateDriverMsg.indexOf(someval) == -1){
        this.setState({
          setLateDriverMsg: [...this.state.setLateDriverMsg,someval]
        });
      }
    }
    if(this.state.drivers.length > 0){
      
      let lastDriver = this.state.drivers.slice(-1).pop();
      if(driverID == lastDriver.id){
        
        if(this.state.setLateDriverMsg.length > 0){
          let infoModal = $('#infomodal');
          $('#infomodallabel').html('Drivers Lists');
          $('#infomodal .modal-body').html("<div class='alert alert-danger'>"+this.state.setLateDriverMsg+"</div>");
          infoModal.modal();
        }
      }
    }
    return false;
  }
  render() {
    let Drivers = [];
    let viewAllJobs = this.state.viewAllJobs;
    // let handleLateDriversFunc = this.handleLateDrivers;
    let saveLateJobIdsOFDriverFunc = this.saveLateJobIdsOFDriver;
    if (this.state.drivers && this.state.drivers.length > 0) {
      this.state.drivers.forEach(function(i) {
        if (i && i.driver) {
          Drivers.push(
            <Driver
              key={'driver-' + i.id}
              data={i}
              jobs={i.jobs}
              viewAllJobs={viewAllJobs}
              // handleLateDrivers={handleLateDriversFunc}
              saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
            />
          );
        }
      });
    }
    return (
      <div className="drivers-table">
        <div className="tab-content-container main-tab-content-container">
          {
          this.state.isLoading ?
            (<div className="loading-box">
                <span className="add-loading-text">
                    <i className="fa fa-spinner fa-pulse"></i>
                </span>
            </div>) :
            Drivers
          }
        </div>
      </div>
    );
  }
}
